import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { ComponentsModules } from '../shared/components/components.module';
import { PipesModules } from '../shared/pipes/pipes.modules';
import { ExampleRoutingModule } from './example-routing.module';
import { ExampleSharedModule } from './example-shared.module';

import { ExampleComponent } from './example.component';
import { ExampleHeaderComponent } from './example-header/example-header.component';


@NgModule({
  declarations: [
    ExampleComponent,
    ExampleHeaderComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    ExampleRoutingModule,
    ComponentsModules,
    PipesModules,
    ExampleSharedModule,
  ],
  providers: [
  ],
  exports: [
  ],
})
export class ExampleModule {}
